import { Component, inject } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PromptService } from '../../../service/prompt.service';
import { AppdataService } from '../../../service/appdata.service';
import { StreamService } from '../../../service/stream.service';
import { SnackService } from '../../../service/snack.service';

@Component({
    selector: 'app-edit-step',
    standalone: false,
    templateUrl: './edit-step.component.html',
    styleUrl: './edit-step.component.scss'
})
export class EditStepComponent {
    readonly step = inject<any>(MAT_DIALOG_DATA);
    readonly dialogRef = inject(MatDialogRef<EditStepComponent>);

    stepPromptVersions: any[] = [{ id: 0, name: `v: 0 | CURRENT` }];
    stepTypes: any[] = [];
    defaultAgentId: any;
    agents: any[] = [];
    history: { [key: string]: any[] } = {};

    // formControls
    initializePrompt: any = {};
    fillOutAllPrompt: any = {};
    stepPrompts: any[] = [];
    closingPrompts: any[] = [];

    formControlCreditCosts: any
    stepVersionFormControl: any;
    stepTypeFormControl: any;


    constructor(
        private fb: FormBuilder,
        private promptService: PromptService,
        private streamService: StreamService,
        private appData: AppdataService,
        private snack: SnackService,
    ) {
        this.stepTypes = this.appData.steTypes
        this.formControlCreditCosts = fb.control(this.step.creditCosts || 0);
        this.stepTypeFormControl = fb.control(this.step.stepTypeId || '');
        this.stepVersionFormControl = this.fb.control(0);

        console.log('Step', this.step);


        this.stepVersionFormControl.valueChanges.subscribe(async (value: any) => {
            this.selectOtherVersion();
        });

        // console.log('Step', this.step);

        appData.agents.subscribe(async (data) => {
            this.agents = data;
            this.defaultAgentId = data?.find((agent) => agent.isDefault === 1)?.id || null;

            this.initializePrompt = { agentControl: this.fb.control(this.defaultAgentId), control: this.fb.control('') };
            this.fillOutAllPrompt = { agentControl: this.fb.control(this.defaultAgentId), control: this.fb.control('') };

            await this.loadStepPrompts();
        });
    }
    async loadStepPrompts() {
        let prompts: any = await this.promptService.getPromptsByTargetId(this.step.id);
        if (prompts.length > 0) {
            await this.initializeAllPrompts(prompts);
            this.loadHistory();
        } else {

            this.stepPrompts.push({ agentControl: this.fb.control(this.defaultAgentId), control: this.fb.control('') });
            this.closingPrompts.push({ agentControl: this.fb.control(this.defaultAgentId), control: this.fb.control('') });
        }

    }

    async initializeAllPrompts(prompts: any) {
        return await new Promise(async (resolve) => {
            this.stepPrompts = [];
            this.closingPrompts = [];
            for await (const prompt of prompts) {

                if (!this.history[prompt.version]) {
                    this.history[prompt.version] = [];
                    let date = new Date(prompt.dateCreated).toLocaleString('de-DE');
                    this.stepPromptVersions = [{ id: prompt.version, name: `v: ${prompt.version} | ${date}` }];
                    this.stepVersionFormControl.setValue(prompt.version);
                }
                if (!this.history['CURRENT']) {
                    this.history['CURRENT'] = [];
                    this.stepPromptVersions = [{ id: 'CURRENT', name: `v: ${prompt.version} | CURRENT VERSION` }];
                    this.stepVersionFormControl.setValue('CURRENT');
                }

                this.history['CURRENT'].push(prompt);
                this.history[prompt.version].push(prompt);

                prompt.control = this.fb.control(prompt.prompt);
                prompt.agentControl = this.fb.control(prompt.agentId);


                if (prompt.promptType === "INITIALIZE_STEP_PROMPT") {
                    this.initializePrompt = prompt;
                } else if (prompt.promptType === "FILL_OUT_ALL_PROMPT") {
                    this.fillOutAllPrompt = prompt;
                } else if (prompt.promptType === "STEP_PROMPT") {
                    this.stepPrompts.push(prompt);
                } else if (prompt.promptType === "CLOSING_STEP_PROMPT") {
                    this.closingPrompts.push(prompt);
                }
            };

            resolve(true);
        });
    }

    async openTestStep() {
        if (this.stepTypeFormControl.value === 'UNSET') return;

        let type = this.stepTypes.find((type) => type.id === this.stepTypeFormControl.value);
        let targetUrl = type.name.toLowerCase().replace(/ /g, '-');
        // console.log('Open Test Step', `home/test-steps/${targetUrl}`);
        // return


        window.open(`test-steps/${targetUrl}?stepId=${this.step.id}&streamId=${this.step.streamId}`, '_teststep');
    }

    async loadHistory() {
        let result = await this.promptService.getHistoryDataByTargetId(this.step.id);
        if (result === false) { return; }

        for await (const prompt of result) {
            if (!this.history[prompt.version]) {
                this.history[prompt.version] = [];
                let date = new Date(prompt.dateCreated).toLocaleString('de-DE');
                this.stepPromptVersions.push({ id: prompt.version, name: `v: ${prompt.version} | ${date}` });
            }
            this.history[prompt.version].push(prompt);
        }
    }

    selectOtherVersion() {
        let prompts = this.history[this.stepVersionFormControl.value];
        console.log('Prompts', prompts);
        console.log('Version', this.stepVersionFormControl.value);
        console.log('History', this.history);

        /* ToDo: Current Object als änderungsobject nehmen
        durch die prompts gehen wenn in history Current

        Wenn change dann prompts aus der jeweiligen Version nehmen
        => initialize direct value update
        => fill out all auch direkt value update

        Step und Closing:
        wenn es mehr prompts in den jeweiligen gibt wie in der zu changenden Version elemente löschen die zu viel sind in dem jeweiligen Array
        und die übrigen nach ID ersetzen
        */
        // this.initializeAllPrompts(prompts);
    }

    addPrompt(promptType: string) {
        if (promptType === "STEP_PROMPT") {
            this.stepPrompts.push({ version: this.stepTypeFormControl.value, agentControl: this.fb.control(this.defaultAgentId), control: this.fb.control('') });
        } else if (promptType === "CLOSING_STEP_PROMPT") {
            this.closingPrompts.push({ version: this.stepTypeFormControl.value, agentControl: this.fb.control(this.defaultAgentId), control: this.fb.control('') });
        }
    }

    removePrompt(promptType: string, index: number) {
        if (promptType === "STEP_PROMPT") {
            this.stepPrompts.splice(index, 1);
        } else if (promptType === "CLOSING_STEP_PROMPT") {
            this.closingPrompts.splice(index, 1);
        }
    }

    async savePrompts() {
        if (this.stepTypeFormControl.value === ''
            || !this.step.id
        ) {
            console.log('Error saving prompts');
            return;
        }

        // Save Initialize Prompts
        let agentId = this.initializePrompt.agentControl.value;
        if (!agentId || agentId == '') agentId = this.defaultAgentId;
        let res = await this.promptService.savePrompt(this.initializePrompt.id || null, this.step.id, agentId, "INITIALIZE_STEP_PROMPT", 0, this.initializePrompt.control.value, 0, null, null);

        if (res === false) {
            console.error('Error saving prompt INITIALIZE_STEP_PROMPT');
            return;
        }
        // Save Initialize Prompts
        agentId = this.fillOutAllPrompt.agentControl.value;
        if (!agentId || agentId == '') agentId = this.defaultAgentId;
        res = await this.promptService.savePrompt(this.fillOutAllPrompt.id || null, this.step.id, agentId, "FILL_OUT_ALL_PROMPT", 0, this.fillOutAllPrompt.control.value, 0, null, null);

        if (res === false) {
            console.error('Error saving prompt FILL_OUT_ALL_PROMPT');
            return;
        }


        // Save Step Prompts
        let index = 0;
        for (let i = 0; i < this.stepPrompts.length; i++) {
            let prompt = this.stepPrompts[i];
            let agentId = prompt.agentControl.value;
            if (!agentId || agentId == '') agentId = this.defaultAgentId;
            let res = await this.promptService.savePrompt(prompt.id || null, this.step.id, agentId, "STEP_PROMPT", index, prompt.control.value, 0, null, null);
            index++;
            if (res === false) {
                console.error('Error saving prompt STEP_PROMPT');
                return;
            }
        }
        index = 0;
        // Save Closing Prompts
        for (let i = 0; i < this.closingPrompts.length; i++) {
            let prompt = this.closingPrompts[i];
            let agentId = prompt.agentControl.value;
            if (!agentId || agentId == '') agentId = this.defaultAgentId;
            let res = await this.promptService.savePrompt(prompt.id || null, this.step.id, agentId, "CLOSING_STEP_PROMPT", index, prompt.control.value, 0, null, null);
            index++;
            if (res === false) {
                console.error('Error saving prompt CLOSING_STEP_PROMPT');
                return;
            }
        }

        let result: any = await this.streamService.updateStreamStep(this.step.id, this.step.streamId, this.stepTypeFormControl.value, this.formControlCreditCosts.value, this.step.orderNr, 0, this.stepPrompts.length - 1, this.closingPrompts.length - 1);
        if (result !== false) {
            this.snack.success(result.msg);
            this.appData.loadAllTracks();
            this.loadStepPrompts();
        }
    }

    close() {
        this.dialogRef.close();
    }
}
